module.exports = __webpack_public_path__ + "img/headshot-jianniello.52403e9e.png";